var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mei-model-portfolio-container"},[_c('div',[_c('portfolio-performance'),_c('portfolio-details'),_c('div',[_c('model-portfolio-footer')],1)],1),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }